import {
    Box,
    Paper, Typography, useTheme,
    RadioGroup as MuiRadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    Icon,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { IDadosJogadoresLesionados, IDadosLesionados, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { FranquiaService, IDadosPicks, IListaDadosPicks } from "../../shered/services/api/franquia/FranquiaService";

const tiposFiltro = [
    {
        codigo: 1,
        label: "NBA"
    },
    {
        codigo: 2,
        label: "Liga"
    },
];

export const ListagemDePicks: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [redirecionar, setRedirecionar] = useState("");
    const [removeLoading, setRemoveLoading] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [tipoFiltro, setTipoFiltro] = useState(1);
    const [dadosPikcs, setDadosPicks] = useState<IDadosPicks[]>([]);
    const [picksRows, setPicksRows] = useState<IListaDadosPicks[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [codigoFranquiaLigaFiltro, setCodigoFranquiaLigaFiltro] = useState(0);
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });


    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: 75,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'descricao_Temporada',
            headerName: 'TEMPORADA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 190,
            maxWidth: UtilidadeService.isMobile() ? 110 : 190,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            color: params.row.observacao ? "#fbc02d" : "auto",
                            cursor: params.row.observacao ? "pointer" : "auto"
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia_Original',
            headerName: 'LOGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            maxWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            //width: 90,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagemescudo.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome_Franquia_Original',
            headerName: 'FRANQUIA',
            description: 'Nome da Franquia Original',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 180 : 230,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            color: params.row.observacao ? "#fbc02d" : "auto",
                            cursor: params.row.observacao ? "pointer" : "auto"
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'rodada',
            headerName: 'RODADA',            
            flex: 1,            
            sortable: false,
            minWidth: UtilidadeService.isMobile() ? 75 : 100,
            maxWidth: UtilidadeService.isMobile() ? 75 : 100,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",

        },
        {
            field: "posicao_Final",
            headerName: "ESCOLHA",
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 100,
            maxWidth: UtilidadeService.isMobile() ? 85 : 100,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? params.value : "-"
        },
        {
            field: "observacao",
            headerName: "OBSERVAÇÃO",
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 230 : 250,
            editable: false,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            color: params.value ? "#fbc02d" : "auto",
                            cursor: params.value ? "pointer" : "auto"
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
    ];

    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        setDadosPicks([]);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
                    let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                    setLstFranquias(lstFranquia);
                }).catch((errors) => {
                    setRemoveLoading(true);
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 2",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        // if (liga.caminho_Logo !== null) {
                        //     setShowImagemFranquia(liga.caminho_Logo);
                        // }
                        carregarDadosPicks(liga.codigo);
                       // setIsLoading(false);
                      //  setRemoveLoading(true);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });

            })
        }
    }, [codigoLiga]);


    const carregarDadosPicks = async (codigoLiga: number) => {        
        setIsLoading(true);
        setRemoveLoading(false);
        await FranquiaService.getPicksPorLigaFranquiaTemporada(codigoLiga, codigoFranquiaLigaFiltro, temporadaFiltro)
            .then((result) => {
                const dados = result.dado;
                setDadosPicks(dados);
                setRemoveLoading(true);
                setIsLoading(false);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });

    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }


    return (
        <LayoutBaseDePagina
            titulo={`Picks - ${dadosLiga?.nome}`}
            showLogoImg={dadosLiga?.caminho_Logo}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Lista das Picks por Franquias </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} spacing={2} paddingTop={2}>
                                <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                        <Select
                                            variant="outlined"
                                            value={codigoFranquiaLigaFiltro}
                                            label="Franquia Liga"
                                            onChange={(e) => setCodigoFranquiaLigaFiltro(Number(e.target.value))}
                                        >
                                            <MenuItem value={0}>Todas</MenuItem>
                                            <MenuItem value={-1}>Sem Franquia</MenuItem>
                                            {
                                                lstFranquias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(e) => setTemporadaFiltro(Number(e.target.value))}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid  size={{xs:6, sm:2, md:2}} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => carregarDadosPicks(Number(dadosLiga?.codigo))}
                                        startIcon={<Icon>change_circle</Icon>}
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid size={{xs:12, sm:12, md:12}} margin={1} spacing={1} paddingBottom={1}>
                                {!removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {dadosPikcs.length > 0 && dadosPikcs.map(f => (
                                    <>                                        
                                        <Grid key={f.codigo_Franquia} container size={{ xs: 12, sm: 12 }} padding={1}>
                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} display={"flex"} flexDirection={"row"} alignSelf={"center"}>
                                                <img src={f.logo_Franquia === "" || f.logo_Franquia === null ? showImagemFranquia : f.logo_Franquia} width={UtilidadeService.isMobile() ? 45 : 80} height={UtilidadeService.isMobile() ? 45 : 80} alt={f.nome_Franquia} />
                                                &nbsp; &nbsp; &nbsp;
                                                <Typography alignSelf={"center"} variant={UtilidadeService.isMobile() ? "body2" : "h6"} >{f.nome_Franquia}</Typography>
                                                &nbsp; &nbsp; &nbsp;
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={UtilidadeService.isMobile() ? 0 : 2} spacing={UtilidadeService.isMobile() ? 1 : 3}>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo}
                                                            rows={f.picks}
                                                            columns={columnsJogadores}
                                                            columnVisibilityModel={{ codigo: false }}
                                                            pageSizeOptions={[24, 50, 100]}
                                                            autoHeight
                                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                                            }}
                                                            disableRowSelectionOnClick                                                            
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            hideFooter
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <hr />
                                        </Grid>
                                    </>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}

